export default __webpack_public_path__ + "static/media/avatar-s-8.df23f034.jpg";